import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import Vue from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller';

// https://github.com/Akryum/vue-virtual-scroller/tree/v1/packages/vue-virtual-scroller#recyclescroller
Vue.use(VueVirtualScroller);
